<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Generador de Reporte de Asiste Libros</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="row">
          <div class="col-sm-6">
            <h6>Fecha inicio</h6>
            <input
              v-model="current.fecha_inicio"
              class="form-control form-control-lg"
              type="date"
            />
          </div>
          <div class="col-sm-6">
            <h6>Fecha Final</h6>
            <input
              v-model="current.fecha_fin"
              class="form-control form-control-lg"
              type="date"
            />
          </div>
        </div>
        <div class="form-inline justify-content-sm-start">
          <div v-if="current.fecha_inicio && current.fecha_fin">
            <br />
            <button
              class="btn btn-success"
              ref="cerrarModal"
              type="button"
              @click="GenerarReporte(current)"
            >
              <i class="fa fa-print"></i>
              Generar Reporte
            </button>
          </div>
          &nbsp; &nbsp;
          <div v-if="current.fecha_inicio && current.fecha_fin">
            <br />
            <button
              class="btn btn-dark"
              ref="cerrarModal"
              type="button"
              @click="cleanData(current)"
            >
              <i class="fa fa-sync"></i>
              Refrescar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {},
  data() {
    return {
      mostrarRefresh: false,
      current: {},
      currentPage: 1,
      searchtext: "",
      filter_activo: "",
      data: [],
    };
  },
  mounted() {},
  methods: {
    GenerarReporte(current) {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API.replace(/\/api/g, "");
      if (this.current.fecha_inicio) {
        this.current.fecha_inicio = moment(this.current.fecha_inicio).format(
          "DD/MM/YYYY"
        );
      }
      if (this.current.fecha_fin) {
        this.current.fecha_fin = moment(this.current.fecha_fin).format(
          "DD/MM/YYYY"
        );
      }
      DynamicService.postActionList(
        "cxc",
        "cargos",
        "ventas_asistelibros",
        this.current
      ).then((response) => {
        let self = this;
        window.open(`${baseApiUrl}${response.data.url}`);
      });
    },
    cleanData() {
      this.current.fecha_inicio = "";
      this.current.fecha_fin = "";
    },
  },
};
</script>